<template>
  <div class="CProductAttr">
    <div class="leftCont">
      <div class="tit">产品属性</div>
      <el-radio-group v-model="leftRadio" @change="radioChange()">
        <el-radio-button v-for="(item,index) in leftData" :key="index" :label="item.id">{{item.name}} <i v-if="leftRadio == item.id" class="leftIcon el-icon-caret-right"></i></el-radio-button>
      </el-radio-group>
    </div>
    <div class="rightCont">
      <!-- 搜索框 -->
      <div class="searchBox">
        <el-input class="searchInput" placeholder="关键词搜索" v-model="keyword.name" clearable  @keyup.enter.native="searchFun()"></el-input>
        <el-button class="searchBtn" type="primary" @click="searchFun()">搜 索</el-button>
      </div>
      <!-- 添加信息 -->
      <div class="addButton">
        <el-button type="primary" @click="openDio('add')">添加</el-button>
      </div>

      <el-table v-loading="loading" :data="productData" style="width: 100%">
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <template v-if="leftRadio == '1'">
        <el-table-column label="类别编号" prop="Id"></el-table-column>
        <el-table-column label="类别名称" prop="Name"></el-table-column>
        <el-table-column label="上级类别" prop="ParentName"></el-table-column>
        <el-table-column label="创建时间" prop="CreatedTime"></el-table-column>
        <el-table-column label="备注" prop="Remarks"></el-table-column>
        </template>
        <template v-else-if="leftRadio == '2'">
        <el-table-column label="单位编号" prop="Id"></el-table-column>
        <el-table-column label="单位名称" prop="Name"></el-table-column>
        <el-table-column label="创建时间" prop="CreatedTime"></el-table-column>
        <el-table-column label="备注" prop="Remarks"></el-table-column>
        </template>
        <template v-else-if="leftRadio == '3'">
        <el-table-column label="客户编号" prop=""></el-table-column>
        <el-table-column label="客户名称" prop=""></el-table-column>
        <el-table-column label="地址" prop=""></el-table-column>
        <el-table-column label="联系人" prop=""></el-table-column>
        <el-table-column label="电话" prop=""></el-table-column>
        <el-table-column label="备注" prop=""></el-table-column>
        </template>
        <template v-else>
        <el-table-column label="供应商编号" prop="Id"></el-table-column>
        <el-table-column label="供应商名称" prop="Name"></el-table-column>
        <el-table-column label="联系人" prop="Contacts"></el-table-column>
        <el-table-column label="电话" prop="Phone"></el-table-column>
        <el-table-column label="地址" prop="Address"></el-table-column>
        </template>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="openDio('edit',scope.row)">修改</el-button>
            <el-button type="text" @click="openDio('del',scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paging" v-if="total>limits">
        <el-pagination
          @current-change="CurrentChange"
          :current-page.sync="curr"
          :page-size="limits"
          layout="prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog :title="dioTitle" :visible.sync="productDio" :width="dioWidth" class="configDio wareDio" center @close="closeDio">
      <div class="contDio">
        <el-form ref="form" :rules="rules" :model="dioform" label-width="90px">
          <template v-if="leftRadio == '1'">
            <el-form-item label="类别名称:" prop="name">
              <el-input v-model="dioform.name"></el-input>
            </el-form-item>
            <el-form-item label="上级类别:" prop="parentsId">
              <el-select v-model="dioform.parentsId">
                <el-option :label="item.Name" :disabled="dioform.id === item.Id && item.Id != 0" :value="item.Id" v-for="(item,index) in typeList" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input v-model="dioform.desc"></el-input>
            </el-form-item>
          </template>
          <template v-else-if="leftRadio == '2'">
            <el-form-item label="单位名称:" prop="name">
              <el-input v-model="dioform.name"></el-input>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input v-model="dioform.desc"></el-input>
            </el-form-item>
          </template>
          <template v-else-if="leftRadio == '3'">
            <el-form-item label="客户名称:" prop="name">
              <el-input v-model="dioform.name"></el-input>
            </el-form-item>
            <el-form-item label="地址:">
              <el-input v-model="dioform.address"></el-input>
            </el-form-item>
            <el-form-item label="联系人:" prop="userName">
              <el-input v-model="dioform.userName"></el-input>
            </el-form-item>
            <el-form-item label="电话:" prop="phone">
              <el-input v-model="dioform.phone"></el-input>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input v-model="dioform.desc"></el-input>
            </el-form-item>
          </template>
          <template v-else-if="leftRadio == '4'">
            <el-form-item label="供应商名称:" prop="name">
              <el-input v-model="dioform.name"></el-input>
            </el-form-item>
            <el-form-item label="联系人:" prop="userName">
              <el-input v-model="dioform.userName"></el-input>
            </el-form-item>
            <el-form-item label="电话:" prop="phone">
              <el-input v-model="dioform.phone"></el-input>
            </el-form-item>
            <el-form-item label="地址:">
              <el-input v-model="dioform.address"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="">
            <el-button type="primary" @click="submitForm('form')">确认</el-button>
            <el-button @click="productDio = false">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>

  </div>
</template>
<script>
  import { bussinessApi } from '../../../../../static/js/api'
  import { showToast } from "../../../../../static/js/utility/utility.js"
  var vm
  export default {
    data(){
      return {
        leftRadio:'1',
        leftData:[{
          id:'1',
          name:'类别'
        },{
          id:'2',
          name:'单位'
        },
        // {
        //   id:'3',
        //   name:'客户'
        // },
        {
          id:'4',
          name:'供应商'
        }],

        //搜索
        keyword:{
          name:'',//关键词搜索
        },

        loading:false,//产品
        productData:[],//产品信息数据

        //分页
        curr:1,
        limits:10,
        total:10,

        dioTitle:'',//弹窗标题
        dioWidth:'',//弹窗宽度
        dioType:'',//弹窗类型
        productDio:false,//弹窗状态
        dioform:{
          id:'',//ID
          name:'',//名称
          parentsId:'',//上级类别
          address:'',//地址
          userName:'',//联系人
          phone:'',//电话
          desc:'',//备注
        },
        typeList:[],//类别下拉列表

        rules:{
          name:[
            { required: true, message: '请输入名称', trigger: 'blur' },
          ],
          parentsId:[
            { required: true, message: '请选择上级类别', trigger: 'blur' },
          ],
          userName:[
            { required: true, message: '请输入联系人', trigger: 'blur' },
          ],
          phone:[
            { required: true, message: '请输入电话', trigger: 'blur' },
          ],
        },
        
      }
    },
    created(){
      vm = this
      this.ProductTypeList()
    },
    methods:{
      
      //提交form表单
      submitForm(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if(vm.leftRadio == '1'){
              if(vm.dioform.id == ''){
                vm.UpdateProductType('add')
              }else{
                vm.UpdateProductType('edit')
              }
            }else if(vm.leftRadio == '2'){
              if(vm.dioform.id == ''){
                vm.UpdateProductUnit('add')
              }else{
                vm.UpdateProductUnit('edit')
              }
            }else if(vm.leftRadio == '4'){
              if(vm.dioform.id == ''){
                vm.UpdateProductSupplier('add')
              }else{
                vm.UpdateProductSupplier('edit')
              }
            }

          } else {return false;}
        });
      },
      //搜索
      searchFun(){
        if(this.leftRadio == '1'){
          this.ProductTypeList(1)
        }else if(this.leftRadio == '2'){
          this.ProductUnitList(1)
        }else{
          this.ProductSupplierList(1)
        }
      },
      //左侧栏切换
      radioChange(){
        this.curr = 1
        this.keyword.name = ''
      },
      //关闭弹窗
      closeDio(){
        vm.dioform={
          id:'',//ID
          name:'',//名称
          parentsId:'',//上级类别
          address:'',//地址
          userName:'',//联系人
          phone:'',//电话
          desc:'',//备注
        }
      },
      //打开弹窗
      openDio(type,info){
        if(type != 'del'){
          vm.dioType = type
          if(vm.leftRadio == '1'){
            vm.ProductTypeList(1,99999)
            if(type == 'add'){
              vm.dioWidth="600px"
              vm.dioTitle="添加类别"
            }else if(type == 'edit'){
              vm.dioWidth="600px"
              vm.dioTitle="修改类别"
              vm.dioform.id = info.Id
              vm.dioform.name = info.Name
              vm.dioform.parentsId = info.ParentId != 0 ? info.ParentId : ''
              vm.dioform.desc = info.Remarks
            }
          }else if(vm.leftRadio == '2'){
            if(type == 'add'){
              vm.dioWidth="600px"
              vm.dioTitle="添加单位"
            }else if(type == 'edit'){
              vm.dioWidth="600px"
              vm.dioTitle="修改单位"
              vm.dioform.id = info.Id
              vm.dioform.name = info.Name
              vm.dioform.desc = info.Remarks
            }
          }else if(vm.leftRadio == '3'){
            if(type == 'add'){
              vm.dioWidth="600px"
              vm.dioTitle="添加客户"
            }
          }else if(vm.leftRadio == '4'){
            if(type == 'add'){
              vm.dioWidth="600px"
              vm.dioTitle="添加供应商"
            }else if(type == 'edit'){
              vm.dioWidth="600px"
              vm.dioTitle="修改供应商"
              vm.dioform.id = info.Id
              vm.dioform.name = info.Name
              vm.dioform.userName = info.Contacts
              vm.dioform.phone = info.Phone
              vm.dioform.address = info.Address
            }
          }
          vm.productDio = true
        }else{
          vm.dioform.id = info.Id
          vm.$confirm('确定删除该项？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if(vm.leftRadio == '1'){
              vm.UpdateProductType('del')
            }else if(vm.leftRadio == '2'){
              vm.UpdateProductUnit('del')
            }else{
              vm.UpdateProductSupplier('del')
            }
          }).catch(() => {});
        }
      },
      //更改类别
      async UpdateProductType(type){
        var data=new Object()
        if(type !='del'){
          data = {
            'TypeName': vm.dioform.name,
            'ParentId': vm.dioform.parentsId,
            'Remarks': vm.dioform.desc,
          }
        }
        if(type == 'edit' || type == 'del'){
          data.TypeId = vm.dioform.id
        }
        const res = await bussinessApi.UpdateProductType(data)
        if(res.ErrCode == 0){
          showToast('操作成功')
          vm.productDio = false
          vm.ProductTypeList(1)
          vm.dioform={
            id:'',//ID
            name:'',//名称
            parentsId:'',//上级类别
            address:'',//地址
            userName:'',//联系人
            phone:'',//电话
            desc:'',//备注
          }
        }else{
          showToast(res.ErrMsg)
        }
      },
      //更改单位
      async UpdateProductUnit(type){
        let data
        if(type !='del'){
          data = {
            'UnitName': vm.dioform.name,
            'Remarks': vm.dioform.desc,
          }
        }
        if(type == 'edit' || type == 'del'){
          data.UnitId = vm.dioform.id
        }
        const res = await bussinessApi.UpdateProductUnit(data)
        if(res.ErrCode == 0){
          showToast('操作成功')
          vm.productDio = false
          vm.ProductUnitList(1)
          vm.dioform={
            id:'',//ID
            name:'',//名称
            parentsId:'',//上级类别
            address:'',//地址
            userName:'',//联系人
            phone:'',//电话
            desc:'',//备注
          }
        }else{
          showToast(res.ErrMsg)
        }
      },
      //更改供应商
      async UpdateProductSupplier(type){
        let data
        if(type !='del'){
          data = {
            'SupplierName': vm.dioform.name,
            'Contacts': vm.dioform.userName,
            'Phone': vm.dioform.phone,
            'Address': vm.dioform.address,
          }
        }
        if(type == 'edit' || type == 'del'){
          data.SupplierId = vm.dioform.id
        }
        const res = await bussinessApi.UpdateProductSupplier(data)
        if(res.ErrCode == 0){
          showToast('操作成功')
          vm.productDio = false
          vm.ProductSupplierList(1)
          vm.dioform={
            id:'',//ID
            name:'',//名称
            parentsId:'',//上级类别
            address:'',//地址
            userName:'',//联系人
            phone:'',//电话
            desc:'',//备注
          }
        }else{
          showToast(res.ErrMsg)
        }
      },
      //类别列表
      async ProductTypeList(curr,limits){
        let data = {
          "KeyWord": vm.keyword.name,
          "Curr": curr ? curr : vm.curr,
          "Limits": limits ? limits : vm.limits,
        }
        vm.loading = true
        const res = await bussinessApi.ProductTypeList(data)
        vm.loading = false
        if(res.ErrCode == 0){
          if(res.Result){
            if(limits === 99999){
              var obj = {
                Id:0,
                Name:'无',
              }
              res.Result.List.unshift(obj)
              vm.typeList = res.Result.List
            }else{
              vm.productData = res.Result.List
              vm.curr = parseInt(res.Result.Curr)
              vm.total = parseInt(res.Result.Total)
            }
          }
        }else{
          showToast(res.ErrMsg)
        }
      },
      //单位列表
      async ProductUnitList(curr,limits){
        let data = {
          "KeyWord": vm.keyword.name,
          "Curr": curr ? curr : vm.curr,
          "Limits": limits ? limits : vm.limits,
        }
        vm.loading = true
        const res = await bussinessApi.ProductUnitList(data)
        vm.loading = false
        if(res.ErrCode == 0){
          vm.productData = res.Result.list
          vm.curr = parseInt(res.Result.Curr)
          vm.total = parseInt(res.Result.Total)
        }else{
          showToast(res.ErrMsg)
        }
      },
      //供应商列表
      async ProductSupplierList(curr,limits){
        let data = {
          "KeyWord": vm.keyword.name,
          "Curr": curr ? curr : vm.curr,
          "Limits": limits ? limits : vm.limits,
        }
        vm.loading = true
        const res = await bussinessApi.ProductSupplierList(data)
        vm.loading = false
        if(res.ErrCode == 0){
          vm.productData = res.Result.list
          vm.curr = parseInt(res.Result.Curr)
          vm.total = parseInt(res.Result.Total)
        }else{
          showToast(res.ErrMsg)
        }
      },
      //分页
      CurrentChange(val){
        this.curr = val
        //执行列表方法
        if(this.leftRadio == '1'){
          this.ProductTypeList(val)
        }else if(this.leftRadio == '2'){
          this.ProductUnitList(val)
        }else{
          this.ProductSupplierList(val)
        }
      },
    },
  }
</script>
<style lang="scss">
.CProductAttr{
  display: flex;
  .leftCont{
    width: 260px;
    height: calc(100vh - 161px);
    flex-shrink: 0;
    border-right:1px solid #ddd;
    .tit{
      border-bottom: 1px solid #ddd;
      font-weight: bold;
      font-size: 16px;
      padding: 10px 20px;
    }
    .el-radio-group{
      display: block;
      .el-radio-button{
        display: block;
        .leftIcon{
          position: absolute;
          right: 20px;
          top: 50%;
          font-size: 20px;
          margin-top: -9px;
          color: #409EFF;
        }
        .el-radio-button__inner{
          display: block;
          border: none;
          border-bottom: 1px solid #ddd;
          border-radius: 0;
        }
        .el-radio-button__orig-radio:checked+.el-radio-button__inner{
          background: none;
          color: #409EFF;
        }
      }
    }
    
  }
  .rightCont{
    padding: 24px;
    flex-grow: 1;
  }
  .w100{
    width: 100px;
  }
  .w200{
    width: 200px;
  }
  .w300{
    width: 300px;
  }
  .searchBox {
    margin-bottom: 20px;
    .searchInput {
      width: 300px;
    }
  }
  
}
</style>


// WEBPACK FOOTER //
// src/components/Page/CStorage/CProductManage/CProductAttr.vue